/**
 * <ActivityDetailsSkeleton> — la forme de la fiche d'une activité pendant qu'elle se lit.
 *
 * L'en-tête de la fiche (`<ActivityDetailsHeader>`) : le titre, puis la chip de matière, le
 * chapitre, la chip de statut et la durée ; puis l'énoncé, son intitulé vrai et ses lignes à la
 * taille du texte de l'énoncé. La fenêtre et sa croix restent : c'est son corps qui attend.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { RichTextSkeleton } from "../../molecules/RichText/RichTextSkeleton"

export function ActivityDetailsSkeleton() {
    return (
        <Stack gap="5">
            <Stack gap="3">
                <Skeleton textSize="text-2xl" width={230} />
                <Row gap="2" align="center" style={styles.meta}>
                    <SubjectBadgeSkeleton />
                    <Skeleton textSize="text-sm" width={150} />
                    <Skeleton shape="chip" width={70} />
                    <Skeleton textSize="text-sm" width={70} />
                </Row>
            </Stack>
            <Stack gap="3">
                <SectionLabel>Énoncé</SectionLabel>
                <RichTextSkeleton lines={4} />
            </Stack>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    meta: { flexWrap: "wrap" as const },
}))
